module.exports = "<titre-bandeau></titre-bandeau>\n<div class=\"topics\">\n    <div class=\"container\">\n        <mot-president></mot-president>\n        <notre-action></notre-action>\n    </div>\n    <div class=\"container\">\n        <historique></historique>\n    </div>\n    <div class=\"container\">\n        <membres></membres>\n    </div>\n    <div class=\"container\">\n        <dons></dons>\n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.template.html
// module id = 6
// module chunks = 0